import { NotFoundPage } from '@/components/NotFoundPage';

const NotFound = () => {
  return <NotFoundPage variant='page' />;
};

export { NotFound };
